import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

import api from '../../utils/api';
import generateId from '../../utils/generateId';

import { MuiRouterLink, WarningButton } from '../CustomMui';
import LockContext from '../../contexts/LockContext';
import { usePrevious } from '../../hooks';

const ownSecondaryText = "You currently have this item locked for edits in another window or you closed the window before saving. Would you like to discard those edits to continue editing from this window?"

// Displays dialog with information re: locked status of interactive along with available actions
export const LockedDialog = ({setNotification}) => {
  
  const { lock } = useContext(LockContext); 
  const isLocked = !!lock.owner;

  const [id] = useState(generateId('lockedDialog-'));
  const [open, setOpen] = useState(isLocked);

  const wasLocked = usePrevious(isLocked);

  const user = useSelector(state => state.user);

  // Close dialog
  const handleClose = () => {
    setOpen(false);
  };

  // Displays dialog when interactive was already open
  // and someone else edited and saved in the meantime
  useEffect(() => {
    if (lock.refresh) {
      setOpen(lock.refresh)
    }
  }, [lock.refresh])
  
  useEffect(() => {
    if (isLocked && !wasLocked && !lock.isCurrent) {
      setOpen(isLocked)
    }
  }, [lock.isCurrent,isLocked,wasLocked])


  // Handle user unlocking own interactive
  const handleDeleteLock = () => {
    api.unlockIntv(lock.id)
      .then((res) => {
        setNotification({
          open: true,
          message: 'Item was successfully unlocked.',
          severity: 'success',
        });

        // Gets interactive again with no lock
        // Simpler and cleaner than setting everything in state correctly
        window.location.reload();

      })
      .catch((err) => {
        setNotification({
          open: true,
          message: 'An error occurred. Item was not unlocked and changes will not be saved.',
          severity: 'error',
        });
        handleClose();
      })
      
  }

  const otherSecondaryText = `This item is currently being edited by ${lock.owner}. Any changes made cannot be saved.`;

  const ownLock = lock.ownerEmail === `${user.email}`

  const renderActionButton = () => {
    if (lock.refresh) {
      return (
        <Button onClick={() => { window.location.reload() }} color="primary">
          Refresh
        </Button>
      )
    } else if (ownLock && !lock.newlyLocked) {
      return (
        <WarningButton onClick={handleDeleteLock} disabled={false}>
          Yes, discard
        </WarningButton>
      )
    } else if (!ownLock) {
      return (
        <Button onClick={handleClose} color="primary">
          Okay
        </Button>
      )
    }
  }

  return (
    
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-title"
      aria-describedby="delete-description"
    >

      <DialogTitle id="delete-title">Item is locked.</DialogTitle>

      <DialogContent>
        <DialogContentText id={`${id}-description`} component="div">
          {ownLock ? ownSecondaryText : otherSecondaryText}
        </DialogContentText>
      </DialogContent>

      <DialogActions>

          <Button component={MuiRouterLink} to={'/'} color="primary" autoFocus>
            Go back
          </Button>


          {renderActionButton()}
          
      </DialogActions>

    </Dialog>

  )
}